import { useEffect } from 'react'

import { LocalStorageKey } from 'shared/constants/localStorage'
import { lsGetItem, lsRemoveItem, lsSetItem } from 'shared/utils/local-storage'
import { create } from 'zustand'

export type ContainerAppTheme = 'light' | 'dark'

const useThemeStore = create<{
  theme: ContainerAppTheme
  setTheme: (theme: ContainerAppTheme) => void
}>(set => ({
  theme: lsGetItem(LocalStorageKey.THEME) ?? 'light',
  setTheme: (theme: ContainerAppTheme) => {
    set({ theme })
  }
}))

export const useTheme = () => {
  const themeStore = useThemeStore()

  function setTheme(theme: ContainerAppTheme) {
    themeStore.setTheme(theme)

    if (theme === 'dark') lsSetItem(LocalStorageKey.THEME, theme)
    else lsRemoveItem(LocalStorageKey.THEME)
  }

  return { theme: themeStore.theme, setTheme }
}

export const useThemeService = () => {
  const themeStore = useThemeStore()

  useEffect(() => {
    document.documentElement.classList.toggle(
      'dark',
      themeStore.theme === 'dark'
    )
  }, [themeStore.theme])
}
